import React from 'react'

const About = () => {
  return (
    <div>Hilly Billy Healthcare</div>
  )
}

export default About